import { ScheduleApi } from './scheduleApi';

export const getApi = (tokenProvider: () => Promise<string>) => {
    return {
        schedule: new ScheduleApi(tokenProvider),
    };
};
